<template>
  <div class="group-photo">
    <div :class="['group-wrapper', { 'has-survol': hasSurvolImage }]" ref="groupWrapper">
      <div class="survol" :style="survolBackground"></div>
      <div class="principale" :style="principaleBackground"></div>
    </div>
    <div
      class="smalltxt texte-photographe"
      v-html="equipeData.texte_photographe"
      v-if="equipeData.texte_photographe"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupPhoto',
  props: {
    equipeData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    principaleBackground() {
      const url = this.equipeData.image_principale.url;
      return url ? { backgroundImage: `url(${url})` } : {};
    },
    survolBackground() {
      const url = this.equipeData.image_survol.url;
      return url ? { backgroundImage: `url(${url})` } : {};
    },
    hasSurvolImage() {
      return !!this.equipeData.image_survol.url;
    },
  },
  mounted() {
    this.addTouchListeners();
  },
  beforeDestroy() {
    this.removeTouchListeners();
  },
  methods: {
    addTouchListeners() {
      const groupWrapper = this.$refs.groupWrapper;
      if (groupWrapper && this.hasSurvolImage) {
        groupWrapper.addEventListener('touchstart', this.handleTouchStart);
        groupWrapper.addEventListener('touchend', this.handleTouchEnd);
      }
    },
    removeTouchListeners() {
      const groupWrapper = this.$refs.groupWrapper;
      if (groupWrapper && this.hasSurvolImage) {
        groupWrapper.removeEventListener('touchstart', this.handleTouchStart);
        groupWrapper.removeEventListener('touchend', this.handleTouchEnd);
      }
    },
    handleTouchStart() {
      this.toggleTouchHover(true);
    },
    handleTouchEnd() {
      this.toggleTouchHover(false);
    },
    toggleTouchHover(state) {
      const groupWrapper = this.$refs.groupWrapper;
      if (groupWrapper) {
        groupWrapper.classList.toggle('touch-hover', state);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';
.group-wrapper {
  width: 100%;
  max-width: 500px;
  position: relative;
  aspect-ratio: 4/5;
  margin-bottom: 20px;
  background-color: #eee;
  overflow: hidden;
  .principale,
  .survol {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    left: 0;
  }
  .principale {
    transition: all 0.6s;
  }
  .survol {
    transform: scale(1.1);
    transition: all 0.6s;
  }
  &.has-survol {
    cursor: pointer;
  }
  &.has-survol:hover,
  &.has-survol.touch-hover {
    .principale {
      opacity: 0;
      transform: scale(1.1);
    }
    .survol {
      transform: scale(1);
    }
  }
}
.group-photo {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
  flex: 1.5;
  .texte-photographe {
    align-self: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/GroupPhoto.vue